import { Box, useRadio, UseRadioProps } from '@chakra-ui/react';

export const RadioCard = (props: UseRadioProps & { children: React.ReactNode }) => {
    const { getInputProps, getRadioProps } = useRadio(props);

    const input = getInputProps();
    const checkbox = getRadioProps();

    return (
        <Box as="label">
            <input {...input} />
            <Box
                {...checkbox}
                cursor="pointer"
                borderWidth="2px"
                borderRadius="lg"
                boxShadow="sm"
                _checked={{
                    bg: 'primary.500',
                    color: 'white',
                    borderColor: 'primary.500',
                }}
                _hover={{
                    borderColor: 'primary.500',
                }}
                _focus={{
                    boxShadow: 'outline',
                }}
                px={5}
                py={3}
                transition="all 0.2s"
            >
                {props.children}
            </Box>
        </Box>
    );
};
